"use strict";

const formValidation = require("../components/formValidation");
const formA11y = require("../components/formA11y");
const createErrorNotification = require("../components/errorNotification");
const passwordValidation = require("../components/passwordValidation");
const grecaptcha = require("int_google/grecaptcha");
const errorBlockClassName = $(".customer-error").length ? ".customer-error" : ".g-recaptcha-response-error";
const { pageViewEvent, authenticateCustomerEvents, formSubmitEvents } = require("../helpers/gtmHelpers");
const { changeSelectPlaceholder } = require("../profile/profile");
const { processFailedAttempts, handleMigratedCustomer } = require("../helpers/loginHelpers");
let failedAttempts = 0;

module.exports = {
    triggerPageView: function () {
        if (!$(".data-checkout-stage").length && !$(".wishlist-landing-page").length) {
            const pageType = $(".reset-password-title").length ? "Reset Password" : "Login/Register Page";
            pageViewEvent(pageType);
        }
    },

    login: function () {
        $("form.login").submit(function (e) {
            e.preventDefault();
            grecaptcha.initRecaptcha(function (token) {
                const form = $("form.login");
                const tokenInput = form.find("input[name=\"g-recaptcha-response\"]");
                tokenInput.length > 0 ? tokenInput.val(token) : form.append(grecaptcha.createInputResponse(token));
                const url = form.attr("action");
                $(errorBlockClassName).empty();
                form.spinner().start();
                form.trigger("login:submit", e);
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: form.serialize(),
                    success: function (data) {
                        form.spinner().stop();

                        if (!data.success) {
                            if (data.recaptchaError && form.find("input[name=\"g-recaptcha-response\"]").length > 0) {
                                $(errorBlockClassName).empty();
                                createErrorNotification(errorBlockClassName, data.msg);
                            }
                            formValidation(form, data);
                            form.trigger("login:error", data);
                            failedAttempts = processFailedAttempts(failedAttempts);
                        } else {
                            if (data.isCustomerMigrated && !data.bcryptHash) {
                                $("#passwordResetModalMigrated").modal("show");
                            } else if (data.isCustomerMigrated && data.bcryptHash) {
                                handleMigratedCustomer(data, form, failedAttempts).then(updatedFailedAttempts => {
                                    failedAttempts = updatedFailedAttempts;
                                });
                            } else {
                                form.trigger("login:success", data);
                                authenticateCustomerEvents(data.userData, "Login Page", "user_login", true);
                                location.href = data.redirectUrl;
                            }
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON && data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            form.trigger("login:error", data);
                            form.spinner().stop();
                        }
                    }
                });
                return false;
            });
        });
    },

    register: function () {
        const registerForm = $("form.registration");

        $(".registration input").on("invalid", function () {
            $(errorBlockClassName).empty();
            $("html, body").animate({
                scrollTop: $(".is-invalid").first().offset().top - 160
            }, 500);
        });

        registerForm.submit(function (e) {
            e.preventDefault();
            $.spinner().start();
            grecaptcha.initRecaptcha(function (token) {
                const form = $("form.registration");
                const tokenInput = form.find("input[name=\"g-recaptcha-response\"]");
                tokenInput.length > 0 ? tokenInput.val(token) : form.append(grecaptcha.createInputResponse(token));
                const url = form.attr("action");
                form.trigger("login:register", e);
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: form.serialize(),
                    success: function (data) {
                        if (!data.success) {
                            $(errorBlockClassName).empty();
                            if (data.recaptchaError && form.find("input[name=\"g-recaptcha-response\"]").length > 0) {
                                if (!data.fields) {
                                    createErrorNotification(errorBlockClassName, data.msg);
                                }
                            }
                            form.trigger("login:register:error", data);
                            formValidation(form, data);
                            const invalidElements = $(".is-invalid");

                            if (invalidElements.length) {
                                $("html, body").animate({
                                    scrollTop: $(".is-invalid").offset().top - 160
                                }, 500);
                            }
                        } else {
                            $(errorBlockClassName).empty();
                            form.trigger("login:register:success", data);
                            authenticateCustomerEvents(data.userData, "Register Page", "user_create_account", false);
                            location.href = data.redirectUrl;
                        }

                        $.spinner().stop();
                    },
                    error: function (err) {
                        if (err.responseJSON && err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification($(".error-messaging"), err.responseJSON.errorMessage);
                        }

                        $.spinner().stop();
                    }
                });
                return false;
            });
        });
    },

    /**
     * Handles the submission of the reset password form
     * @returns {boolean} - false to prevent form submission
     */
    resetPassword: function () {
        passwordValidation();
        $(".reset-password-form").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            const $submitEmailButton = $("#submitEmailButton");
            form.spinner().start();
            $(".reset-password-form").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $(".reset-password-form").closest(".modal-body").addClass("fulfilled");
                        $(".request-password-title").text(data.receivedMsgHeading);
                        $(".request-password-body").empty()
                            .append("<p class='password-reset-description'>" + data.receivedMsgBody + "</p>");
                        formSubmitEvents("Reset password form");
                        if (!data.mobile) {
                            $submitEmailButton.text($submitEmailButton.attr("data-go-to-account"))
                                .attr("data-dismiss", "modal");
                        } else {
                            $(".send-email-btn").empty()
                                .html("<a href=\""
                                    + data.returnUrl
                                    + "\" class=\"btn btn-primary--black reset-btn\">"
                                    + data.buttonText + "</a>"
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    /**
    * Sets event for submitting new password form
    */
    setNewPasswordEvent: function () {
        $(".set-new-password-form").on("submit", () => {
            formSubmitEvents("Set new password");
        });
    },

    clearResetForm: function () {
        $("#login .modal").on("hidden.bs.modal", function () {
            $("#reset-password-email").val("");
            $(".modal-dialog .form-control.is-invalid").removeClass("is-invalid");
            formA11y.clearInvalid($(".modal-dialog"));
        });
    },

    /**
    * Event handler for input events on birth details input fields
    * If the input value is not a number, it will be removed
    */
    inputEvent: function () {
        $(".birth-details input[type='text']").on("input", function () {
            const input = $(this);
            const inputVal = +input.val();
            if (isNaN(inputVal)) {
                input.val("");
            }
        });
    },
    changeSelectPlaceholder : changeSelectPlaceholder
};
